/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiPlatformFromJSON, ApiPlatformToJSON, } from './ApiPlatform';
export function ApiSignupRequestFromJSON(json) {
    return ApiSignupRequestFromJSONTyped(json, false);
}
export function ApiSignupRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !exists(json, 'email') ? undefined : json['email'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'platform': !exists(json, 'platform') ? undefined : ApiPlatformFromJSON(json['platform']),
        'storeUrl': !exists(json, 'storeUrl') ? undefined : json['storeUrl'],
    };
}
export function ApiSignupRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'name': value.name,
        'phoneNumber': value.phoneNumber,
        'platform': ApiPlatformToJSON(value.platform),
        'storeUrl': value.storeUrl,
    };
}
